import type { FC } from 'react';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Grid, Box } from '@material-ui/core';
import { connect } from 'react-redux';
import Panel from '../../../components/global/Panel';
import PanelHeader from '../../../components/global/PanelHeader';
import PanelTitle from '../../../components/global/PanelTitle';
import PanelFilter from '../../../components/admin/PanelFilter';
import AvanceMensualFacturacion from './AvanceMensualFacturacion';
import AvanceMensualComposicion from './AvanceMensualComposicion';
import AvanceMensualCanal from './AvanceMensualCanal';
import useIsMountedRef from '../../../hooks/useIsMountedRef';
import { onGet } from '../../../store/actions/global';

const AvanceMensual: FC<any> = ({ onGet: onGetExec }) => {
  const isMountedRef = useIsMountedRef();
  const defaultLimit = 10;
  const title = 'Avance Mensual Convenios';
  const [factConvenioBar, setFactConvenioBar] = useState({
    labels: [],
    values: [],
    totalBar: '0',
  });
  const [factComparation, setFactComparation] = useState({
    data: [],
    header: { monthPrev: '', monthBest: '' },
    pages: { total: 0, current: 0, limit: 0 },
    resume: { facturacion: 0, facturacionPrev: 0, facturacionBest: 0, porcPrevMonth: 0, porcBestMonth: 0 }
  });
  const [valuesFilter, setValuesFilter] = useState({
    year: null,
    month: null,
    yearMonthPrev: '',
    yearMonthBest: '',
  });
  const [canal, setCanal] = useState({
    data: [],
    header: { monthPrev: '', monthBest: '' },
    resume: { facturacion: 0, facturacionPrev: 0, facturacionBest: 0, porcPrevMonth: 0, porcBestMonth: 0 }
  });

  const onSubmit = async (values) => {
    if (isMountedRef.current) {
      setValuesFilter(values);
      const response = await onGetExec({
        url: '/dashboard/avance-mensual',
        body: { ...values, limit: defaultLimit },
      });
      const yearMonthPrev = response?.factComparation?.header?.yearMonthPrev || '';
      const yearMonthBest = response?.factComparation?.header?.yearMonthBest || '';
      setFactConvenioBar(response?.factConvenioBar);
      setFactComparation(response?.factComparation);
      setCanal(response?.factCanal);
      setValuesFilter((item) => ({
        ...item,
        yearMonthPrev,
        yearMonthBest,
      }));
    }
  };

  const handleChangePage = async (event: unknown, page: number) => {
    const { year, month, yearMonthPrev, yearMonthBest } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/avance-mensual/detail',
      body: {
        year,
        month,
        yearMonthPrev,
        yearMonthBest,
        limit: Number(factComparation.pages.limit),
        page,
        type: 'CONVENIO',
      },
    });
    setFactComparation(response);
  };

  const handleChangeRowsPerPage = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { year, month, yearMonthPrev, yearMonthBest } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/avance-mensual/detail',
      body: {
        year,
        month,
        yearMonthPrev,
        yearMonthBest,
        limit: Number(event.target.value),
        page: 0,
        type: 'CONVENIO',
      },
    });
    setFactComparation(response);
  };

  return (
    <>
      <Helmet>
        <title>
          Dashboard:
          {title}
        </title>
      </Helmet>
      <Panel>
        <PanelHeader>
          <PanelTitle
            title={title}
            subTitlePrim="Dashboard"
            subTitleSec={title}
          />
        </PanelHeader>
        <PanelFilter onSubmit={onSubmit} yearMonth />
        <Box pt={3}>
          <Grid container spacing={2}>
            <Grid item md={5} xs={12}>
              <AvanceMensualFacturacion content={factConvenioBar} />
            </Grid>
            <Grid item md={7} xs={12}>
              <AvanceMensualCanal content={canal} />
            </Grid>
            <Grid item md={12} xs={12}>
              <AvanceMensualComposicion
                content={factComparation}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </Grid>
          </Grid>
        </Box>
      </Panel>
    </>
  );
};

export default connect(null, {
  onGet,
})(AvanceMensual);
